import { useTranslation } from 'react-i18next';
import {
    Divider,
    Card,
    Avatar,
    Button,
    Space,
    notification,
} from 'antd';
import { dateFormat } from '@/helpers/dateFormat';
import { actions } from '@/redux/invoice/create/reducer';
import { removeUnnecessaryValues } from '../removeValues';

const RoomList = ({
    roomListSelected,
    dateStartEnd,
    replace,
    dispatch,
    notificationKey,
    tourId,
    currency,
}) => {
    const { t } = useTranslation();

    // prepare data for reservation
    let reservationData = null;
    const keysToRemove = [
        'total_price',
        'room_img',
        'price_type',
        'room_type_total_price',
    ];

    reservationData = {
        reservation_type: 'Tour Package',
        tour_id: tourId,
        date_start: dateStartEnd[0]?.format(dateFormat),
        date_end: dateStartEnd[1]?.format(dateFormat),
        currency_icon: currency,
        data: roomListSelected,
    };

    const bookNow = () => {
        dispatch(actions.clearInvoiceState());
        dispatch(actions.prepareReservationDataForSubmit(reservationData));
        dispatch(actions.requestGetReservationData(
            tourId,
            {
                type: 2,
                data: removeUnnecessaryValues(roomListSelected, keysToRemove),
            },
        ));
        replace('/app/invoices/new');
        setTimeout(() => {
            notification.close(notificationKey);
        }, 1000);
    };
    return (
        <>
            <Divider />
            {roomListSelected.map((room) => (
                <div key={room.room_type}>
                    <Card bordered={false}>
                        <Card.Meta
                            avatar={<Avatar src={room.room_img} />}
                            title={(
                                <Space size={65}>
                                    <span className="room-type_name">{t(room.type_name)}</span>
                                    <span className="room-type_total_price">
                                        {room.price_type}
                                        {room.room_type_total_price}
                                    </span>
                                </Space>
                            )}
                            description={(
                                <div className="selected-details">
                                    <div>
                                        {`${t('Number of Rooms')}: ${room.no_rooms}`}
                                    </div>
                                </div>
                            )}
                        />
                    </Card>
                    <Divider dashed />
                </div>
            ))}
            <div>
                <Button
                    block
                    onClick={bookNow}
                >
                    {t('Book now').toUpperCase()}
                </Button>
            </div>
        </>
    );
};

export default RoomList;
